import axios from 'axios';
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://mycashcanvas.com:5000',
  timeout: 40000,
});

apiClient.interceptors.request.use(
  (config) => {
    try {
      const authData = JSON.parse(localStorage.getItem('authData') || '{}');
      const token = authData?.accessToken;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.error('Auth token error:', error);
      localStorage.removeItem('authData');
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  response => response,
  error => {
    const responseError = {
      message: error.response?.data?.message || error.message,
      status: error.response?.status || 500,
      code: error.code || 'INTERNAL_ERROR',
      data: error.response?.data,
      config: error.config
    };

    const customError = new Error(responseError.message);
    Object.assign(customError, responseError);
    
    console.error('API Error:', responseError);
    return Promise.reject(customError);
  }
);
export default apiClient;

